import { useEffect, useState } from "react";
import Index from "@/pages/Index";
import { ExperimentVariantProvider } from "@/context/ExperimentContext";
import { type LandingVariant } from "@/lib/experiment";

const LandingExperiment = () => {
  const [variant, setVariant] = useState<LandingVariant | null>(null);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const controller = new AbortController();

    const fetchVariant = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const requestedVariant = params.get("variant")?.toString().trim().toUpperCase();
        if (requestedVariant === "B") {
          window.location.replace(`${window.location.origin}/`);
          return;
        }

        const requestUrl = new URL("/api/experiment/variant", window.location.origin);
        if (requestedVariant === "A") {
          requestUrl.searchParams.set("variant", requestedVariant);
        }
        const response = await fetch(requestUrl.toString(), {
          signal: controller.signal,
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`unexpected status ${response.status}`);
        }

        await response.json();
        setVariant("A");
      } catch (error) {
        if (controller.signal.aborted) {
          return;
        }
        console.warn("[LandingExperiment] Falha ao buscar variante remota", error);
        setVariant("A");
      }
    };

    fetchVariant();

    return () => {
      controller.abort();
    };
  }, []);

  useEffect(() => {
    if (!variant || typeof document === "undefined") {
      return;
    }
    document.documentElement.dataset.landingVariant = variant;
    return () => {
      if (document.documentElement.dataset.landingVariant === variant) {
        delete document.documentElement.dataset.landingVariant;
      }
    };
  }, [variant]);

  if (!variant) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="space-y-3 text-center">
          <div className="mx-auto h-1.5 w-40 animate-pulse rounded-full bg-muted" />
          <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">
            Preparando experiência
          </p>
        </div>
      </div>
    );
  }

  return (
    <ExperimentVariantProvider value={variant}>
      <Index />
    </ExperimentVariantProvider>
  );
};

export default LandingExperiment;
